import React, { useState, useEffect } from "react";
import { engApi } from "../../api/engApi";
import DrawerReviewCompany from "./DrawerReviewCompany";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { optionsBranch } from "../../data/branch-data";
import { getCompany } from "../../api/crud";

const CompamyEdit = () => {
  const { register, control, watch, reset } = useForm();
  const getUsername = localStorage.getItem("username");
  const [companySelected, setCompanySelected] = useState(null);
  const [companyTarget, setCompanyTarget] = useState(null);
  const [optionsCompany, setOptionsCompany] = useState([]);

  const getCompanyList = async () => {
    getCompany()
      .then((res) => {
        const list = res
          .map((company) => {
            return {
              label: `${company.id} : ${company.name}`,
              value: company.id,
              data: company,
            };
          })
          .filter((el) => el.data.waiting == "0");

        setOptionsCompany(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getCompanyList();
  }, []);

  useEffect(() => {
    console.log("useEff", companySelected);

    if (companySelected && optionsBranch.length) {
      const branchArr = companySelected?.data.branch
        .replaceAll(" ", ",")
        .split(",");

      const branchOpts = branchArr.map((item) => {
        return optionsBranch.find((el) => el?.label == item);
      });

      const defaultValues = {
        // cp_id: companySelected?.data?.id,
        cp_name: companySelected?.data?.name,
        cp_address: companySelected?.data?.address,
        cp_road: companySelected?.data?.road,
        cp_subdistrict: companySelected?.data?.subdistrict,
        cp_district: companySelected?.data?.district,
        cp_province: companySelected?.data?.province,
        cp_zip: companySelected?.data?.zip,
        cp_tel: companySelected?.data?.tel,
        cp_email: companySelected?.data?.email,
        cp_branch_raw: branchOpts,
      };

      reset(defaultValues);
    }
  }, [companySelected, optionsBranch]);

  const displayBody = (
    <div className="p-2">
      <div className="mb-2">
        <Select
          options={optionsCompany}
          onChange={(ev) => {
            setCompanySelected(ev);
          }}
          value={companySelected}
          isClearable
        />
      </div>

      {companySelected && (
        <div className="row g-3">
          <div className="col-md-3">รหัสสถานประกอบการ</div>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control border-0"
              readOnly
              name="cp_id"
              value={companySelected?.data?.id}
            />
          </div>
          <div className="col-md-3">ชื่อสถานประกอบการ</div>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control "
              {...register("cp_name")}
            />
          </div>
          <div className="col-md-3">ที่อยู่</div>
          <div className="col-md-3">
            <input
              type="text"
              className="form-control "
              {...register("cp_address")}
            />
          </div>
          <div className="col-md-3">ถนน</div>
          <div className="col-md-3">
            <input
              type="text"
              className="form-control "
              {...register("cp_road")}
            />
          </div>
          <div className="col-md-3">ตำบล</div>
          <div className="col-md-3">
            <input
              type="text"
              className="form-control "
              {...register("cp_subdistrict")}
            />
          </div>
          <div className="col-md-3">อำเภอ</div>
          <div className="col-md-3">
            <input
              type="text"
              className="form-control "
              {...register("cp_district")}
            />
          </div>
          <div className="col-md-3">จังหวัด</div>
          <div className="col-md-3">
            <input
              type="text"
              className="form-control "
              {...register("cp_province")}
            />
          </div>
          <div className="col-md-3">รหัสไปรษณีย์</div>
          <div className="col-md-3">
            <input
              type="number"
              className="form-control "
              {...register("cp_zip")}
            />
          </div>
          <div className="col-md-3">เบอร์โทร</div>
          <div className="col-md-3">
            <input
              type="text"
              className="form-control "
              {...register("cp_tel")}
            />
          </div>
          <div className="col-md-3">อีเมล</div>
          <div className="col-md-3">
            <input
              type="email"
              className="form-control "
              {...register("cp_email")}
            />
          </div>
          <div className="col-md-3">สาขาที่เกี่ยวข้อง</div>
          <div className="col-md-9">
            <Controller
              name="cp_branch_raw"
              control={control}
              render={({ field }) => {
                return <Select options={optionsBranch} isMulti {...field} />;
              }}
            />
            <input
              className="form-control d-none"
              type="text"
              {...register("cp_branch")}
              value={
                watch("cp_branch_raw") && watch("cp_branch_raw").length
                  ? watch("cp_branch_raw")
                      ?.map((el) => el?.label)
                      ?.join(",")
                  : null
              }
            />
            <input
              className="form-control d-none"
              type="text"
              //   {...register("user")}
              defaultValue={getUsername}
            />
          </div>
          <div className="mt-4 d-flex justify-content-center">
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div>
      <div className="card">
        <div className="card-header">
          <h5 className="card-title">แก้ไขสถานประกอบการ</h5>
          <h6 className="card-subtitle text-muted"></h6>
        </div>
        <div className="card-body">
          <div id="tasks-upcoming">
            <form method="post" action="./update-company.php">
              {displayBody}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompamyEdit;
